import styled from "styled-components";

import background from "./image/background.svg";
import list_marker from "./image/list_marker.svg";

const StylesContainer = styled.div`
  .page-container {
    background: url(${background}) no-repeat;
    background-position: 100% 90%;
    box-sizing: border-box;
    font-family: Poppins, sans-serif;
    padding: 71px 80px 0 78px;
    width: 1230px;
  }

  main {
    align-items: start;
    display: flex;
    gap: 35px;
    justify-content: space-between;
    font-size: 17px;
    line-height: 150%;
    margin: 40px 0 150px;

    h2 {
      color: #4cc9c8;
      font-size: 42px;
      line-height: 120%;
      letter-spacing: -0.84px;
      margin: unset;
    }

    h4 {
      color: #141248;
      font-size: 31px;
      font-weight: 400;
      line-height: 120%;
      letter-spacing: -0.62px;
      margin: unset;
    }

    ul {
      padding-left: 24px;

      li {
        list-style-image: url(${list_marker});
        margin-bottom: 12px;
      }
    }
  }

  footer {
    position: relative;
    color: #2a2a2a;
    display: flex;
    justify-content: space-between;
    letter-spacing: -0.28px;
    line-height: 160%;
    padding: 24px 32px;

    svg {
      position: absolute;
      left: 0;
      top: 0;
    }

    p {
      font-size: 16px;
      margin: unset;
    }

    h5 {
      color: #02494e;
      font-size: 18px;
      font-weight: 800;
      margin: unset;
    }
  }
`;

export default StylesContainer;
